import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getDisabledSpecialitesRequest: ['response'],
    getDisabledSpecialitesSuccess: ['response', 'loading'],
    getDisabledSpecialitesFailure: ['error'],
})

export const getDisabledSpecialitesTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getDisabledSpecialitesSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getDisabledSpecialitesFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getDisabledSpecialitesRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_DISABLED_SPECIALITES_REQUEST]: getDisabledSpecialitesRequest,
    [Types.GET_DISABLED_SPECIALITES_SUCCESS]: getDisabledSpecialitesSuccess,
    [Types.GET_DISABLED_SPECIALITES_FAILURE]: getDisabledSpecialitesFailure,
})
